__turbopack_context__.v({
  "accentLine": "LeaveConversationModal-module-scss-module__2ozH4G__accentLine",
  "actions": "LeaveConversationModal-module-scss-module__2ozH4G__actions",
  "body": "LeaveConversationModal-module-scss-module__2ozH4G__body",
  "browseButton": "LeaveConversationModal-module-scss-module__2ozH4G__browseButton",
  "closeButton": "LeaveConversationModal-module-scss-module__2ozH4G__closeButton",
  "content": "LeaveConversationModal-module-scss-module__2ozH4G__content",
  "fadeIn": "LeaveConversationModal-module-scss-module__2ozH4G__fadeIn",
  "modal": "LeaveConversationModal-module-scss-module__2ozH4G__modal",
  "modalWrapper": "LeaveConversationModal-module-scss-module__2ozH4G__modalWrapper",
  "overlay": "LeaveConversationModal-module-scss-module__2ozH4G__overlay",
  "primaryButton": "LeaveConversationModal-module-scss-module__2ozH4G__primaryButton",
  "slideIn": "LeaveConversationModal-module-scss-module__2ozH4G__slideIn",
  "textContent": "LeaveConversationModal-module-scss-module__2ozH4G__textContent",
  "title": "LeaveConversationModal-module-scss-module__2ozH4G__title",
});
